module.exports = __webpack_public_path__ + "img/ic_profile_wizard_data_and_privacy_settings.b002b3c6.svg";